import { createContext, useContext } from "react"

// It's a fatal error to include a component that depends on a GL without providing an actual GL, hence the casting of null.
export const GLContext = createContext<WebGL2RenderingContext>(null as any)

export function useGL(): WebGL2RenderingContext {
    return useContext(GLContext)
}
